import TrialButton from "./TrialButton";
import { getAuthUrl } from "@/utils/redirectUtils";
import { trackEvent } from "@/utils/tagManagerUtils";

const McpFinalCta = () => {
  const handleSignIn = () => {
    trackEvent("mcp_signin_click", { source: "final_cta" });
  };

  return (
    <section className="py-24 px-4 bg-primary text-primary-foreground">
      <div className="container mx-auto max-w-3xl text-center">
        <h2 className="text-3xl md:text-4xl font-bold">
          Build your first campaign in four minutes
        </h2>
        <p className="mt-4 text-lg text-primary-foreground/80">
          Seven days free, then $99/month. No setup call, no sales pitch,
          no agency retainer.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <TrialButton
            source="final_cta"
            variant="secondary"
            className="bg-background text-foreground hover:bg-background/90"
          />
        </div>
        <p className="mt-6 text-sm text-primary-foreground/80">
          Already have an account?{" "}
          <a
            href={getAuthUrl()}
            onClick={handleSignIn}
            className="underline underline-offset-4 hover:opacity-90"
          >
            Sign in
          </a>
        </p>
      </div>
    </section>
  );
};

export default McpFinalCta;
